import React from 'react';
import { NavLink } from 'react-router-dom';
import KaAlert from '../../Common/KaAlert';
import useDisplayMessage from '../../Common/useDisplayMessage';
import ConnectorFetchView from '../../Common/Sync/ConnectorFetchView';
import useConnectorSync from '../../Common/Sync/useConnectorSync';
import useFetchTransportsFromTmx from '../../../requests/useFetchTransportsFromTmx';
import useGetTransportSyncStatus from '../../../requests/useGetTransportSyncStatus';
import RequiresPermissionTemplate from '../../UserAccess/RequiresPermissionTemplate';
import { TransportSyncReview } from './TransportSyncReview';

const TransportSyncPage = () => {
  const displayMessage = useDisplayMessage();

  const sync = useConnectorSync({
    useTmxFetch: useFetchTransportsFromTmx,
    useStatus: useGetTransportSyncStatus,
  }, {
    onFetchError: message => displayMessage.fail(message),
    onSiteChange: () => displayMessage.clear(),
  });

  return (
    <RequiresPermissionTemplate permission="otherEntitiesModify">
      <div className="ms-n2 pb-3">
        <NavLink className="card-link my-auto text-nowrap" to="/transports" style={{ fontSize: 20 }}>
          <i className="bi-chevron-left" />
          Sync TMX Transports
        </NavLink>
      </div>
      <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
      <ConnectorFetchView sync={sync} entityLabel="Transports">
        <TransportSyncReview
          key={sync.selectedSiteId}
          siteId={sync.selectedSiteId}
          siteLabel={sync.selectedOption?.label}
          displayMessage={displayMessage}
        />
      </ConnectorFetchView>
    </RequiresPermissionTemplate>
  );
};

export { TransportSyncPage };
